export default class OnboardingStatus {
  static Inactive = 'inactive';
  static Active = 'active';
  static Completed = 'completed';
  static NoPrimaryEmail = 'noPrimaryEmail';
}
